import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvScanInfected = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 1.5L3 4.5V13.5C3 18.4711 7.02891 22.5 12 22.5C16.9711 22.5 21 18.4711 21 13.5V4.5L12 1.5ZM19.3125 13.5C19.3125 17.5383 16.0383 20.8125 12 20.8125C7.96172 20.8125 4.6875 17.5383 4.6875 13.5V5.76562L12 3.1875L19.3125 5.76562V13.5Z",
			fill: "currentColor",
			fillOpacity: 1
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 15,
			r: 1,
			fill: "currentColor",
			fillOpacity: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0451 7.54152C11.0208 7.25001 11.2509 7 11.5434 7H12.4566C12.7491 7 12.9792 7.25001 12.9549 7.54152L12.5382 12.5415C12.5166 12.8007 12.3 13 12.0399 13H11.9601C11.7 13 11.4834 12.8007 11.4618 12.5415L11.0451 7.54152Z",
			fill: "currentColor",
			fillOpacity: 1
		})
	]
});
export default SvgAvScanInfected;
